<form name="metadataForm" [formGroup]="metadataForm" novalidate>
    <header-bar [pageTitle]="title" headingClass="fa-circle-o"></header-bar>

    <div class="container mt-5 mb-5">
        <div class="alert alert-info mb-5" *ngIf="disabled">
            <strong><span class="fa fa-pencil mr-2"></span>Details of this metadata item may not be edited.</strong>  you may however associate <strong> new </strong> countries.
        </div>
        <div class="row">
            <div class="col">
                <div class="card mb-5">
                    <div class="card-header bg-primary text-white">
                        <div class="row align-items-center">
                            <p class="h3 m-0 col">Metadata details</p>
                            <div class="col text-right">
                                <button type="submit" class="btn btn-outline-light btn-sm u-marginBottom--medium" [disabled]="!metadataForm.valid" (click)="saveMetadata(metadataForm.value);">
                                    Save <i class="fa fa-check ml-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <p class="textBody--xs u-marginBottom--medium">Please complete all fields marked with an asterix (*)</p>

                                <div class="row" [ngClass]="{ 'has-error' : !metadataForm.controls['type'].valid && metadataForm.controls['type'].touched }">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="type">Type *</label>
                                            <ng-select 
                                                [items]="metadataTypes" 
                                                [active]="activeType"
                                                placeholder="Select a type"
                                                [allowClear]="true"
                                                [disabled]="disabled || isLoading"
                                                (selected)="onTypeSelected($event)"
                                                (removed)="onTypeRemoved()">
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="metadataForm.controls['type'].hasError('required') && metadataForm.controls['type'].touched" class="alert alert-danger mt-3">You must select a type</div>
                                <div class="row" [ngClass]="{ 'has-error' : !metadataForm.controls['name'].valid && metadataForm.controls['name'].touched }">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="name">Name *</label>
                                            <input name="name" class="form-control" formControlName="name" />
                                            <div *ngIf="metadataForm.controls['name'].hasError('required') && metadataForm.controls['name'].touched" class="alert alert-danger mt-3">You must include a name</div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="metadataForm.controls['url'] && selectedType && selectedType.id == metadataType.Source" class="row" [ngClass]="{ 'has-error' : !metadataForm.controls['url'].valid && metadataForm.controls['url'].touched }">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="url">Url</label>
                                            <input name="url" class="form-control" formControlName="url" aria-describedby="basic-addon1" />
                                            <div *ngIf="metadataForm.controls['url'].hasError('pattern') && metadataForm.controls['url'].touched" class="alert alert-danger mt-3">Please include http:// or https:// to the beginning of your URL </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <label for="disabled">Is this metadata disabled?</label>
                                        <input type="checkbox" name="disabled" formControlName="disabled" class="u-marginTop--small" />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Valid countries</label>
                                    <p class="form-text">Which countries is this metadata valid for?</p>
                                    <p class="alert alert-info">
                                        <input type="checkbox" value="false" [checked]="selectAll" (click)="selectAllCountries()" /> {{selectAll ? 'Deselect all countries' : 'Select all countries' }} 
                                    </p>
                                    <div class="row" [formGroup]="metadataForm.controls['countries']">
                                        <div class="col col-md-4" *ngFor="let c of allCountries">
                                            <input type="checkbox" [formControlName]="c.id">
                                            {{ c.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<confirmationmodal #confirmModal (onAccept)="onAccept();" (onDecline)="onDecline();"></confirmationmodal>
